import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectVertragsoptionen = (state: IAppState): Vertragsoptionen =>
  state.vertragsoptionen;

export type SelectVertragsoptionenReturnType = ReturnType<typeof selectVertragsoptionen>;

export const selectZahlweise = (state: IAppState): string =>
  state.vertragsoptionen.zahlungsweise.toLowerCase();

export const selectIsNeugeschaeft = (state: IAppState): boolean =>
  !state.vertragsoptionen.vorvertragsNummern ||
  state.vertragsoptionen.vorvertragsNummern.length === 0;
